module.exports = __webpack_public_path__ + "img/desc.1a6727dc.png";